import React, { useState } from "react";
import styled from "styled-components";
import copy from "../img/copy.png";
import search from "../img/search.png";
import toggle_down from "../img/toggle_down.png";
import toggle_up from "../img/toggle_up.svg";
import CaseSummary from "./CaseSummary.jsx";
import Text from "../Components/Text.jsx";
import Button from "../Components/Button.jsx";
import HeightInterval from "../Components/HeightInterval.jsx";
import CaseComparison from "../Components/CaseComparison.jsx";
import ModalPayCheck from "./Modal/ModalPayCheck";
import RelevanceChart from "../Components/ApexChart/RelevanceChart.jsx";
import TooltipComponent from "./Tooltip.jsx";
import { gradientBorder } from "../styles/mixin.js";
import useStore from "../store.js";
import ModalPrecedentGuide from "./Modal/ModalPrecedentGuide";
import { formatCaseText } from "./caseTextFormatter.js";

/* ResultForm Mobile 버전 */
const ResultFormMobile = ({
  index,
  courtName,
  sentencingData,
  caseNumber,
  caption,
  relevance,
  question,
  detail,
  answer,
  caseId,
  anchorId,
  isComparison,
  commonality,
  difference,
  error,
}) => {
  const [showCompare, setShowCompare] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showPrecedentGuideModal, setShowPrecedentGuideModal] = useState(false);
  // const [isLoading, setIsLoading] = useState(false); // CaseComparison의 props로부터 추가된 로딩 상태
  const { setShowCopyCaseSnackbar } = useStore();

  // 스낵바는 Mobile에만 우선 적용하기 위해 위해 현재 화면의 가로 크기 가져오기
  const screenWidth = window.innerWidth;

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleConfirmModal = () => {
    setShowModal(false); // 모달 닫기
    setShowCompare(true); // CaseComparison 보여주기
  };

  // 구글에 원문 검색
  const handleSearch = () => {
    const query = `${courtName} ${caseNumber}`;
    const url = `https://www.google.com/search?q=${encodeURIComponent(query)}`;
    window.open(url, "_blank");
  };

  // 복사하기
  const handleCopy = () => {
    const formattedQuestion = formatCaseText(question);
    const formattedAnswer = formatCaseText(answer);
    const formattedDetail = formatCaseText(detail);
    const textToCopy = `
[판례 번호]
${courtName} ${sentencingData} ${caseNumber}

[문제]
${formattedQuestion}

[결론]
${formattedAnswer}

[내용]
${formattedDetail}
    `;
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        // 화면 해상도가 1140px 이하일 때(Mobile, Tablet) 스낵바 사용
        if (screenWidth <= 1140) {
          setShowCopyCaseSnackbar(true);
          // 3초 후 애니메이션이 시작되고, 애니메이션이 완료된 후 사라지게 설정
          setTimeout(() => {
            setShowCopyCaseSnackbar(false);
          }, 6000); // 3초 유지 + 3초 동안 애니메이션 실행 = 총 6초 후 상태 변경
        } else {
          // 해상도가 1140px 보다 클 때(Desktop) window.alert 사용
          alert("판례 내용이 복사되었습니다");
        }
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  /* 이후 - 판례 요약 접어두기 기능 구현  */
  // const [isContentVisible, setIsContentVisible] = useState(false);
  // const handleToggleContent = () => {
  //   setIsContentVisible(!isContentVisible);
  // };

  return (
    <WrapperMobile id={anchorId} tabIndex={anchorId ? -1 : undefined} style={anchorId ? { scrollMarginTop: 128 } : undefined} data-testid="case-card">
      <Header data-testid="case-card-header">
        <TitleAndNumber>
          <Number>#{index + 1}</Number>
          <CaseTitle>
            {courtName} {sentencingData} {caseNumber} / {caption}
          </CaseTitle>
        </TitleAndNumber>
        <Relevance>
          <RelevanceChart relevance={relevance} />
          <Text
            size="10px"
            color="rgba(0, 0, 0, 0.30)"
            weight="400"
            lineHeight="14px">
            관련도
          </Text>
        </Relevance>
      </Header>
      <HrStyles />
      {error ? (
        <>
          <HeightInterval height={20} />
          <ErrorMessage>
            죄송합니다. <br /> 요청하신 내용을 처리하는 중에 오류가 발생했습니다.<br /> 재시도 해주십시오.
          </ErrorMessage>
          <HeightInterval height={20} />
        </>
      ) : (
        <>
          <HeightInterval height={20} />
          <CaseSummary
            question={question}
            detail={detail}
            answer={answer}></CaseSummary>
          <HeightInterval height={showCompare || isComparison ? 36 : 20} />
          <HrStyles />

          {showCompare || isComparison ? (
            <>
              <CaseComparison
                caseId={caseId}
                isComparison={isComparison}
                commonality={commonality}
                difference={difference}
                // setLoading={setIsLoading}
                onCopy={handleCopy}
                onSearch={handleSearch}
              />
            </>
          ) : (
            <>
              <HrStyles />
              <Bottom>
                <Button
                  image_src={copy}
                  alt_text="복사하기"
                  imgWidth={32}
                  imgHeight={32}
                  onClick={handleCopy}></Button>
                <Button
                  image_src={search}
                  alt_text="원문검색"
                  imgWidth={32}
                  imgHeight={32}
                  onClick={() => setShowPrecedentGuideModal(true)}></Button>
                <WrapperTB>
                  <TooltipComponent />
                </WrapperTB>
                <ButtonCompare type="button" onClick={handleOpenModal}>
                  내 상황과 비교하기
                </ButtonCompare>
              </Bottom>
            </>
          )}
        </>
      )}
      <ModalPayCheck
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleConfirmModal}
        law={5}
        buttonType="comparisonButton"
        headerContent="내 상황과 비교하기"
        checkCreditBeforeConfirm={false}
      />
      <ModalPrecedentGuide
        isOpen={showPrecedentGuideModal}
        onClose={() => setShowPrecedentGuideModal(false)}
        courtName={courtName}
        caseNumber={caseNumber}
      />
    </WrapperMobile>
  );
};
/* CaseSummary 가로 세로 비 */
/*  width 비율 = 11% 81% 8% */
/*  height 비율 = 17% 68% 15% */

/* Header 가로 비 */
/* width 비율 = Number : CaseTtile : CaseSummary =  11% : 77% : 12% */

const WrapperMobile = styled.div`
  ${gradientBorder}

  --case-card-border-width: 1px;

  &::before {
    padding: var(--case-card-border-width);
  }

  height: auto;
  width: 100%;
  flex-shrink: 0;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  position: relative; /* 자식 Overlay 의 absolute를 위함 */

  @media (max-width: 1140px) and (min-width: 745px) {
    width: 680px;
  }

  @media (max-width: 744px) and (min-width: 481px) {
    width: auto;
    margin: 0px 32px;
  }

  @media (max-width: 480px) {
    width: 100%;
    // margin: 0px 24px; // 부모 컴포넌트가 24px 좌우 padding을 이미 적용하고 있어서 여기서는 안 해도 됨
  }
`;

const Header = styled.div`
  min-height: 60px;
  margin: 8px 0 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const TitleAndNumber = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1 1 auto;
`;

const Number = styled.div`
  width: auto;
  flex: 0 0 auto;
  margin-left: 18px;
  margin-right: 18px;

  color: rgba(0, 0, 0, 0.6);
  text-align: justify;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`;

const CaseTitle = styled.div`
  min-width: 0;
  height: auto;
  display: flex;
  align-items: center;

  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

const Relevance = styled.div`
  flex: 0 0 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 4px; /* 관련도의 margin-right가 내용들과 일직선 되도록 */
  margin-left: auto;
`;

const Bottom = styled.div`
  height: 72px;
  display: flex;
  //justify-content: center;
  align-items: center;
  margin: 0px 18px;
  gap: 4px;
`;

const ButtonCompare = styled.button`
  height: 40px;
  min-width: 0;
  flex: 1 1 auto;
  border-radius: 8px;
  background: linear-gradient(92deg, #00f370 0%, #00badc 50.5%, #0057ff 100%);
  border: none;
  color: white;
  font-size: 14px;
  font-weight: 700;
  line-height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.8;
  }
`;

const HrStyles = styled.hr`
  position: relative;
  width: 98.6%;
  height: 0px;
  flex-shrink: 0;
  border: 0;
  border-top: 1px solid #f1f1f1;
  margin: 0 0 0 1px; /* 상하 마진 제거 및 회색선 왼쪽 마진 추가 */
`;

const WrapperTB = styled.div`
  display: flex;
  gap: 6px;
`;

/* Toggle Button 관련 */
const Overlay = styled.div`
  position: absolute;
  top: 11%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10; /* 펼쳐지는 Content 보다 값이 커야함 */
`;

const ToggleButton = styled.button`
  width: 149px;
  height: 32px;
  border-radius: 24px;
  border: 1px solid #f1f1f1;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ToggleText = styled.div`
  color: rgba(0, 0, 0, 0.6);
  font-family: Pretendard;
  font-size: 12px;
  font-weight: 500;
  margin-right: 4px;
`;

const ErrorMessage = styled.div`
  color: rgba(0, 0, 0, 0.60);
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  margin: 0 24px;
`;

export default ResultFormMobile;
